<ng-container *ngTemplateOutlet="countdownTemplate; context: { below: !isBelowCountdown }" />
@if (title) {
  <h3 class="title">{{ title }}</h3>
}
@if (subtitle) {
  <div class="subtitle copy-m">{{ subtitle }}</div>
}
<ng-container *ngTemplateOutlet="countdownTemplate; context: { below: isBelowCountdown }" />

<ng-template #countdownTemplate let-below="below">
  @if (below) {
    <div class="countdown-container">
      @if (countDownReached && postCountdownLabel) {
        <div class="pre-countdown-text">
          {{ postCountdownLabel }}
        </div>
      }
      @if (countdownDate && !countDownReached) {
        <div class="counter">
          <mb-countdown
            (finished)="finished()"
            [countdownTo]="countdownDate"
            [countdownLabel]="countdownLabel || ''"
            [countdownType]="showDaysOnly ? countdownType.DAYS : countdownType.FULL"
          ></mb-countdown>
        </div>
      }
    </div>
  }
</ng-template>
